export default class ClaimHelper {
  static decodeJWT(jwt?: string | null): Record<string, any> | undefined {
    if (!jwt) {
      return undefined;
    }

    try {
      const base64Url = jwt.split('.')[1];
      const decoded = ClaimHelper.atob(base64Url);
      const parsed = JSON.parse(decoded);

      if (parsed.dat) {
        return parsed.dat;
      }

      return {
        role: 'user',
        status: parsed.status || 'active',
      };
    } catch (e) {
      console.error('Error decoding JWT:', e);
      return undefined;
    }
  }

  static atob(base64Encoded: string): string {
    return Buffer.from(base64Encoded, 'base64').toString();
  }
}
